"use client";

import { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import { ASSETS_URL } from "@/Constant";

const TeamOne = ({ Type = 1, TestiMonialsData = [] }) => {
  const [openModal, setOpenModal] = useState(null);

  return (
    <div className="container">
      {Type === 1 && (
        <div className="row row--15">
          <div className="col-lg-12">
          <Swiper
            modules={[Navigation, Pagination]}
            spaceBetween={20}
            slidesPerView={1}
            navigation
            loop={true} // 🔄 Infinite scroll
            pagination={{ clickable: true }}
            breakpoints={{
              768: { slidesPerView: 2 },
              1024: { slidesPerView: 4 },
            }}
          >
              {TestiMonialsData.map((data, index) => (
                <SwiperSlide key={index}>
                  <div className="rbt-team-modal-thumb nav nav-tabs mobile_flex_justify_center">
                    <div
                      className="rbt-team-thumbnail"
                      onClick={() => data?.Video?.src && setOpenModal(index)}
                      style={{
                        cursor: data?.Video?.src ? "pointer" : "default",
                      }}
                    >
                      <div className="thumb" style={{ position: "relative" }}>
                        <img
                          src={`${ASSETS_URL}/${data?.banner?.src}`}
                          width={415}
                          height={555}
                          alt="Testimonial Images"
                        />
                        {data?.Video?.src && (
                          <button
                            style={{
                              position: "absolute",
                              bottom: "10px",
                              left: "10px",
                              border: "none",
                              backgroundColor: "transparent",
                              color: "white",
                              cursor: "pointer",
                              fontSize: "16px",
                              zIndex: 1,
                            }}
                          >
                            <div
                              className="rbt-btn rounded-player-2 popup-video position-to-top with-animation btn-white-color"
                              style={{ height: "30px", width: "30px" }}
                            >
                              <span className="play-icon"></span>
                            </div>
                          </button>
                        )}
                      </div>
                      <div
                        style={{
                          display: "flex",
                          // alignItems: "center",
                          marginTop: "16px",
                          gap: "16px",
                        }}
                      >
                        <img
                          src={`${ASSETS_URL}/${data?.banner?.src}`}
                          alt="sd"
                          style={{
                            width: "4rem",
                            height: "4rem",
                            objectFit: "cover",
                            borderRadius: "9999px",
                            backgroundColor: "#6B7280",
                          }}
                        />
                        <div>
                          <p
                            style={{
                              fontSize: "1.125rem",
                              fontWeight: 600,
                              marginBottom: "0.5rem",
                            }}
                          >
                            {data?.name}
                          </p>
                          {data?.university?.name && (
                            <p
                              style={{ fontSize: "0.875rem", color: "#4B5563" }}
                            >
                              {data?.university?.name}
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      )}

      {Type === 2 && (
        <div className="d-grid responsiveGridTemplateComng4 gap-4">
          {TestiMonialsData?.map((data, index) => (
            <div className="rbt-team-modal-thumb nav nav-tabs ">
              <div
                className="rbt-team-thumbnail"
                onClick={() => data?.Video?.src && setOpenModal(index)}
                style={{
                  cursor: data?.Video?.src ? "pointer" : "default",
                }}
              >
                <div className="thumb" style={{ position: "relative" }}>
                  <img
                    src={`${ASSETS_URL}/${data?.banner?.src}`}
                    width={415}
                    height={555}
                    alt="Testimonial Images"
                  />
                  {data?.Video?.src && (
                    <button
                      style={{
                        position: "absolute",
                        bottom: "10px",
                        left: "10px",
                        border: "none",
                        backgroundColor: "transparent",
                        color: "white",
                        cursor: "pointer",
                        fontSize: "16px",
                        zIndex: 1,
                      }}
                    >
                      <div
                        className="rbt-btn rounded-player-2 popup-video position-to-top with-animation btn-white-color"
                        style={{ height: "30px", width: "30px" }}
                      >
                        <span className="play-icon"></span>
                      </div>
                    </button>
                  )}
                </div>
                <div
                  style={{
                    display: "flex",
                    // alignItems: "center",
                    marginTop: "16px",
                    gap: "16px",
                  }}
                >
                  <img
                    src={`${ASSETS_URL}/${data?.banner?.src}`}
                    alt="sd"
                    style={{
                      width: "4rem",
                      height: "4rem",
                      objectFit: "cover",
                      borderRadius: "9999px",
                      backgroundColor: "#6B7280",
                    }}
                  />
                  <div>
                    <p
                      style={{
                        fontSize: "1.125rem",
                        fontWeight: 600,
                        marginBottom: "0.5rem",
                      }}
                    >
                      {data?.name}
                    </p>
                    {data?.university?.name && (
                      <p style={{ fontSize: "0.875rem", color: "#4B5563" }}>
                        {data?.university?.name}
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* MODALS */}
      {TestiMonialsData.map(
        (data, index) =>
          openModal === index && (
            <div
              className="rbt-team-modal modal fade show"
              style={{
                display: "block",
                backgroundColor: "rgba(0, 0, 0, 0.5)",
              }}
              key={index}
            >
              <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                  <div className="modal-header">
                    <h4>Testimonial - {data?.name}</h4>
                    <button
                      type="button"
                      className="rbt-round-btn"
                      onClick={() => setOpenModal(null)}
                      aria-label="Close"
                    >
                      <i className="feather-x"></i>
                    </button>
                  </div>
                  <div className="iframe-container">
                    <div>&nbsp;</div>
                    {data?.Video?.src && (
                      <iframe
                        width="100%"
                        height="400"
                        src={`${ASSETS_URL}/${data?.Video?.src}`}
                        title="Video Player"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerPolicy="strict-origin-when-cross-origin"
                        allowFullScreen
                      ></iframe>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )
      )}
    </div>
  );
};

export default TeamOne;
